import {  solana } from '@reown/appkit/networks';

export default {
  IS_DEV: false,
  API_BASE_URL: 'https://api.junk.fun',
  SOLANA_NETWORK: solana,
  // Set in Vercel env vars. `?.` keeps this importable outside Vite (tsx unit tests)
  SOLANA_RPC_URL: import.meta.env?.VITE_SOLANA_RPC_URL,
  SOLANA: {
    PROGRAM: {
      JUNK_FUN_PROGRAM_ID: 'junkTHpAet6MuYuTfHej12Zh12aWeG6tXbB7hnLjTKi',
    },
  },
  FORCE_PRELAUNCH_GATE: false, // Staging: can toggle if needed for testing
  // Feature Flags
  ENABLE_NEW_LEADERBOARDS: false, // Enable burned/cumulative points leaderboards
  ENABLE_NFT_DEBUG_BYPASS: true, // Staging: Bypass Twitter verification for testing
  ENABLE_NFT_JUNKING: true, // Staging: Enable NFT junking for testing
  ENABLE_SOLFLARE_CAMPAIGN: false, // Solflare campaign has ended
  ENABLE_GATE_WALLET_CAMPAIGN: true, // Show Gate Wallet connect button
  ENABLE_SMB_MATRICA_CAMPAIGN: true, // SMB x Matrica campaign - enabled for testing
  ENABLE_MATTLE_CAMPAIGN: false, // Mattle.fun campaign - not ready for staging
  ENABLE_PHANTOM_EMBEDDED_WALLET: true,
  ENABLE_DUST_SWAP: true, // Staging uses mainnet, dust swapping enabled
  ENABLE_RECLAIM_EXCESS_RENT: true, // Staging: test the excess rent reclaim panel on mainnet accounts
  SHOW_SWAP_PDA_BALANCE: true, // Show user's accumulated swap PDA balance for testing
  ENABLE_PNFT_JUNKING: false, // pNFT burning is not supported by the current on-chain burn flow
  SHOW_ASSET_DISCOVERY_DEBUG: true, // Show asset discovery source in staging for diagnostics
  // Jupiter API version: 'ultra' (faster, single call) or 'legacy' (2-step quote→swap)
  JUPITER_API_VERSION: 'legacy' as 'ultra' | 'legacy',
  ENABLE_WRAPPED: true, // Enable Wrapped 2025 feature
  WRAPPED_END_DATE: '2026-01-07T23:59:59Z', // When Wrapped becomes archived (extended for testing)
  ENABLE_NEW_YEAR_CAMPAIGN: false, // New Year 2026 Campaign ended
  // NFT Tier Thresholds (must match backend constants - using PROD thresholds)
  NFT_TIER_THRESHOLDS: {
    DIAMOND: 50,
    BLACK: 500,
    GOLD: 5000,
    SILVER: 10000,
  },
  // Override WalletConnect metadata for staging
  WALLET_CONNECT_METADATA: {
    name: 'Junk.Fun (Staging)',
    description: 'Junk.Fun - Burn tokens, win prizes',
    url: 'https://staging.junk.fun',
    icons: ['https://www.junk.fun/logo.png'], // Using prod logo (staging is behind Vercel auth)
  },
};
